import * as messageService from "../../services/message.service";
import * as dashboardBDMService from '../../services/dashboardBDM.service';

const state = {
    BDMRecordType:'settlements',
    BDMPeriodMode:'this-month',
    dBDMData:[],
    dBDMThisMonthData:[],
    dBDMLastMonthData:[],
    dBDMLastYearData:[],
    dBDMThisMonthLeadsData:[],
    dBDMLastMonthLeadsData:[],
    dBDMLastYearLeadsData:[],
    dBDMIsDashboardLoading:false,

    allBDMs:[],
    bdmCommissions:[],
    bdmCommissionParam:{},
};

const getters = {
    getBDMRecordType:state => (state.BDMRecordType),
    getBDMPeriodMode:state => (state.BDMPeriodMode),
    getDBDMData:state => (state.dBDMData),
    getDBDMThisMonthData:state => (state.dBDMThisMonthData),
    getDBDMLastMonthData:state => (state.dBDMLastMonthData),
    getDBDMLastYearData:state => (state.dBDMLastYearData),
    getDBDMThisMonthLeadsData:state => (state.dBDMThisMonthLeadsData),
    getDBDMLastMonthLeadsData:state => (state.dBDMLastMonthLeadsData),
    getDBDMLastYearLeadsData:state => (state.dBDMLastYearLeadsData),
    getDBDMIsDashboardLoading:state => (state.dBDMIsDashboardLoading),
    getAllBDMs:state => (state.allBDMs),
    getBDMCommissions:state => (state.bdmCommissions),
    getBDMCommissionParam:state => (state.bdmCommissionParam),
};

const actions = {
    fetchBDMRecordType({ commit }, recordType ){
      commit('setBDMRecordType', recordType);
    },
    fetchBDMPeriodMode({ commit }, periodMode ){
      commit('setBDMPeriodMode', periodMode);
    },

    async fetchDBDMData({ commit }, bdmId ){
        try {
            const response = await dashboardBDMService.all(bdmId);
            commit('setDBDMData', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDBDMThisMonthData({ commit }, obj ){
        try {
            commit('setDBDMIsDashboardLoading', true);
            const response = await dashboardBDMService.thisMonth(obj);
            commit('setDBDMThisMonthData', response.data);
            commit('setDBDMIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDBDMIsDashboardLoading', false);
        }
    },
    async fetchDBDMLastMonthData({ commit }, obj ){
        try {
            commit('setDBDMIsDashboardLoading', true);
            const response = await dashboardBDMService.lastMonth(obj);
            commit('setDBDMLastMonthData', response.data);
            commit('setDBDMIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDBDMIsDashboardLoading', false);
        }
    },
    async fetchDBDMLastYearData({ commit }, obj ){
        try {
            commit('setDBDMIsDashboardLoading', true);
            const response = await dashboardBDMService.lastYear(obj);
            commit('setDBDMLastYearData', response.data);
            commit('setDBDMIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDBDMIsDashboardLoading', false);
        }
    },
    async fetchDBDMThisMonthLeadsData({ commit }, obj ){
        try {
            commit('setDBDMIsDashboardLoading', true);
            const response = await dashboardBDMService.thisMonthLeads(obj);
            commit('setDBDMThisMonthLeadsData', response.data);
            commit('setDBDMIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDBDMIsDashboardLoading', false);
        }
    },
    async fetchDBDMLastMonthLeadsData({ commit }, obj ){
        try {
            commit('setDBDMIsDashboardLoading', true);
            const response = await dashboardBDMService.lastMonthLeads(obj);
            commit('setDBDMLastMonthLeadsData', response.data);
            commit('setDBDMIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDBDMIsDashboardLoading', false);
        }
    },
    async fetchDBDMLastYearLeadsData({ commit }, obj ){
        try {
            commit('setDBDMIsDashboardLoading', true);
            const response = await dashboardBDMService.lastYearLeads(obj);
            commit('setDBDMLastYearLeadsData', response.data);
            commit('setDBDMIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDBDMIsDashboardLoading', false);
        }
    },
    async fetchAllBDMs({ commit } ){
        try {
            const response = await dashboardBDMService.allBDMs();
            commit('setAllBDMs', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }
            messageService.fnSweetAlertDisplay(obj);
        }
    },

    async fetchBDMCommissions({ commit }, obj ){
      try {
          const response = await dashboardBDMService.bdmCommissions(obj);
          commit('setBdmCommissions', response.data);
      } catch (error) {
        commit('setBdmCommissions', error.response.data);
          const obj = {
              "type":'error',
              "title":error.response.data.error.name,
              "text":error.response.data.error.message,
              "footer":'Error code: ' + error.response.data.error.statusCode,
          }
      }
    },
    fetchBDMCommissionParam({ commit }, obj ){
      commit('setBdmCommissionParam', obj);
    },
};

const mutations = {
    setBDMRecordType:(state, res) => (
      state.BDMRecordType =  res
    ),
    setBDMPeriodMode:(state, res) => (
      state.BDMPeriodMode =  res
    ),
    setDBDMData:(state, res) => (
        state.dBDMData =  res
    ),
    setDBDMThisMonthData:(state, res) => (
        state.dBDMThisMonthData =  res
    ),
    setDBDMLastMonthData:(state, res) => (
        state.dBDMLastMonthData =  res
    ),
    setDBDMLastYearData:(state, res) => (
        state.dBDMLastYearData =  res
    ),
    setDBDMThisMonthLeadsData:(state, res) => (
        state.dBDMThisMonthLeadsData =  res
    ),
    setDBDMLastMonthLeadsData:(state, res) => (
        state.dBDMLastMonthLeadsData =  res
    ),
    setDBDMLastYearLeadsData:(state, res) => (
        state.dBDMLastYearLeadsData =  res
    ),
    setDBDMIsDashboardLoading:(state, res) => (
        state.dBDMIsDashboardLoading =  res
    ),
    setAllBDMs:(state, res) => (
        state.allBDMs =  res
    ),
    setBdmCommissions:(state, res) => {
      state.bdmCommissions =  res
    },
    setBdmCommissionParam:(state, res) => {
      state.bdmCommissionParam =  res
    }
};

export default{
    state,
    getters,
    actions,
    mutations,
}
